const Style = {

  header: 'p-6 relative text-center font-semibold z-3 sm:text-left sm:text-md z-10 bg-white rounded-2xl sm:mx-4 shadow',
  title: 'text-xl',

}

export default Style;
